<template>
  <div class="hayaban_osoban">
    <h3>公休申請</h3>
    <template v-if="data">
      <div class="flex">
        <b class="title">就業場所</b>
        <p>{{ data.syuugyou_basyo_name }}</p>
      </div>

      <div class="flex">
        <b class="title">社員番号</b>
        <p>{{ data.staff_code }}</p>
      </div>

      <div class="flex">
        <b class="title">氏名</b>
        <p>{{ data.staff_name }}</p>
      </div>

      <div class="flex">
        <b class="title">公休日 </b>
        <p>{{ data.koukyuu_date }}（{{ data.koukyuuTaniLabel }}）</p>
      </div>
    </template>
  </div>
</template>

<script lang="ts">

import { Ref, defineComponent, onMounted, ref } from 'vue';
import { KoukyuuDetail } from '@/types/Shinsei';
import { KoukyuuService } from '@/service/KoukyuuService';

export default defineComponent({
  props: {
    id: {
      type: Number,
      require: true,
      default: null
    }
  },
  setup(props) {
    const data: Ref<KoukyuuDetail | null> = ref(null)
    const srv = new KoukyuuService()
    onMounted(async () => {
      if(!props.id) {
        return
      }

      data.value = await srv.getDetail(props.id)
    })
    return {
      data
    }
  }
})

</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>